import { Component, OnInit } from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';
import { Router } from '@angular/router';
import {AgentStatusService} from '../../app/agent-status.service'
import { error } from 'util';

@Component({
  selector: 'app-agent-info',
  templateUrl: './agent-info.component.html',
  styleUrls: ['./agent-info.component.css']
})
export class AgentInfoComponent implements OnInit {

  constructor(private storage:LocalStorageService, private router: Router, private agentStatusSvc: AgentStatusService) { }
  agent:String;
  username:String;
  status:String=null;
  ngOnInit() {
    this.agent = this.storage.retrieve("agent");
    this.username = this.storage.retrieve("username");
    if(!this.agent){
      this.router.navigateByUrl('login');
    }
    this.getStatus();
  }

  getStatus(){
    this.agentStatusSvc.getStatus(this.agent).subscribe(resp =>{
      this.status = resp.data.startChatResult.agentStatus.S;
    },
      error=>{
        console.error('error'+JSON.stringify(error));
      })
  }


}
